/* ============================================
   Don Chacho — Nav transparente + sticky
   Archivo: assets/dc-nav.js
   ============================================ */

(function() {
  const header = document.querySelector('.shopify-section-header');
  if (!header) return;

  const heroSection = document.querySelector('.dc-hero-wrapper');
  if (!heroSection) return;

  function updateNav() {
    const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY < heroBottom - 80) {
      header.classList.add('dc-nav-transparent');
      header.classList.remove('dc-nav-sticky');
    } else {
      header.classList.remove('dc-nav-transparent');
      header.classList.add('dc-nav-sticky');
    }
  }

  // Estado inicial
  updateNav();

  // Escuchar scroll
  window.addEventListener('scroll', updateNav, { passive: true });
})();